import { createSlice } from '@reduxjs/toolkit';
import { createInitialStatePart, setReducerState } from '../utils/reduxUtils';

const STATE_KEY = 'support';
const initialState = {
  isActiveSupportMessage: false,
  ...createInitialStatePart('supportForm'),
};

const support = createSlice({
  name: STATE_KEY,
  initialState,
  reducers: {
    toggleSupportMessage: (state, { payload }) => {
      return {...state, isActiveSupportMessage: payload.status};
    },
    submitSupportForm: (state) => {
      return setReducerState('loading', 'supportForm', { state });
    },
    submitSupportFormSuccess: (state, action) => {
      return setReducerState('loaded', 'supportForm', { state, data: action.payload });
    },
    submitSupportFormFail: (state, action) => {
      return setReducerState('error', 'supportForm', { state, error: action.payload });
    },
  },
});

export const {
  toggleSupportMessage,
  submitSupportForm,
  submitSupportFormSuccess,
  submitSupportFormFail
} = support.actions;

export default support.reducer;
